import { render, staticRenderFns } from "./SagasuHansel.vue?vue&type=template&id=3aac1775&"
import script from "./SagasuHansel.vue?vue&type=script&lang=js&"
export * from "./SagasuHansel.vue?vue&type=script&lang=js&"
import style0 from "./SagasuHansel.vue?vue&type=style&index=0&id=3aac1775&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports